import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_REMARK_REQUEST = 'coin/FETCH_REMARK_REQUEST'
const FETCH_REMARK_SUCCESS = 'coin/FETCH_REMARK_SUCCESS'
const FETCH_REMARK_FAILURE = 'coin/FETCH_REMARK_FAILURE'

const CREATE_REMARK_REQUEST = 'coin/CREATE_REMARK_REQUEST'
const CREATE_REMARK_SUCCESS = 'coin/CREATE_REMARK_SUCCESS'
const CREATE_REMARK_FAILURE = 'coin/CREATE_REMARK_FAILURE'

const UPDATE_REMARK_REQUEST = 'coin/UPDATE_REMARK_REQUEST'
const UPDATE_REMARK_SUCCESS = 'coin/UPDATE_REMARK_SUCCESS'
const UPDATE_REMARK_FAILURE = 'coin/UPDATE_REMARK_FAILURE'

const DELETE_REMARK_REQUEST = 'coin/DELETE_REMARK_REQUEST'
const DELETE_REMARK_SUCCESS = 'coin/DELETE_REMARK_SUCCESS'
const DELETE_REMARK_FAILURE = 'coin/DELETE_REMARK_FAILURE'

// Initialize State
const initialState = {
  isLoading: false,
  error: {},
  remark: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REMARK_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_REMARK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        remark: action.payload
      }
    case FETCH_REMARK_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_REMARK_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_REMARK_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_REMARK_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_REMARK_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_REMARK_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_REMARK_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_REMARK_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_REMARK_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_REMARK_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

// Action Creators
export const fetchRemark = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_REMARK_REQUEST
      })
      const response = await API.get(EndPoints.REMARK + `/all`)
      dispatch({
        type: FETCH_REMARK_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_REMARK_FAILURE
      })
    }
  }
}
export const createRemark = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_REMARK_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.REMARK + `/createRemark`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_REMARK_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_REMARK_FAILURE
      })
    }
  }
}
export const updateRemark = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_REMARK_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.REMARK + `/updateRemark`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_REMARK_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_REMARK_FAILURE
      })
    }
  }
}
export const deleteRemark = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_REMARK_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.REMARK + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_REMARK_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_REMARK_FAILURE
      })
    }
  }
}


